import React from "react"
import ContactForm from "../../components/do/ContactForm"
import ContactOther from "../../components/do/ContactOther"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/do/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"

const contact = () => {
  return (
    <Layout>
      <SEO title={PAGE.title.contact} siteTitle="Do" />
      <HeadingL title={PAGE.title.contact} target="do" />
      <ContactForm />
      <ContactOther />
    </Layout>
  )
}

export default contact
